import { FormGroup, FormControl } from '@angular/forms';
import { LanguageControl } from './file-language-control';
import { FileNameControl } from './file-name-control';

export class FileFormGroup extends FormGroup {
    private static readonly fileNameKey = 'fileName';
    private static readonly languageKey = 'language';

    constructor(
        fileFormControl: FormControl, 
        languageFormControl: FormControl
    ) {
        super({
            [FileFormGroup.fileNameKey]: fileFormControl,
            [FileFormGroup.languageKey]: languageFormControl
        });
    }

    public get fileNameControl(): FileNameControl {
        return this.controls[FileFormGroup.fileNameKey] as FileNameControl;
    }

    public get languageControl(): LanguageControl {
        return this.controls[FileFormGroup.languageKey] as LanguageControl;
    }
}